export interface TimelinePoint {
  metric_date: string;
  ios_installs: number;
  signups: number;
  ig_engagement: number;
}

export interface CandidatePost {
  post_id: string;
  permalink: string | null;
  caption: string | null;
  engagement: number;
}

export interface Spike {
  metric_date: string;
  metric: 'ios_installs' | 'signups';
  value: number;
  baseline: number;
  pct_increase: number;
  candidate_posts: CandidatePost[];
}

export interface AttributionData {
  timeline: TimelinePoint[];
  spikes: Spike[];
}

export const EMPTY_ATTRIBUTION: AttributionData = { timeline: [], spikes: [] };
